import priceRange from './priceRange';
import filtersModalsEvents from './filtersModalsEvents';
import axios from 'axios';
import modalDateSearch from '../../../components/SearchCalendarModal';

const filters = (window) => {
  const { document } = window;
  modalDateSearch(window, { http: axios }, true);
  priceRange(window);
  filtersModalsEvents(document);
};

export default filters;
